// SHOULD MATCH IN FE AND API REPOS
import { z } from 'zod';
import { DealerEmailTemplate, DealerProfileFileSchema } from './dealer.model';

export type CreateDealerRequest = z.infer<typeof CreateDealerRequestSchema>;

export const CreateDealerRequestSchema = z.object({
  companyName: z.string().min(2),
  bankName: z.string().optional(),
  phone: z.string(),
  websiteUrl: z.string().optional(),
  emailAddresses: z.array(z.string()),
  emailTemplate: z.enum([DealerEmailTemplate.Default, DealerEmailTemplate.FuturaTrailersInc]),
  customThemeContent: z.string().optional(),
  address: z.object({
    addressLine1: z.string(),
    addressLine2: z.string().optional(),
    city: z.string(),
    state: z.string(),
    zipCode: z.string(),
  }),
  documents: z.array(DealerProfileFileSchema).default([]),
});
